export type FileSizeUnit = 'kb' | 'mb' | 'gb';
export type FileSize = `${number}${FileSizeUnit}`;
export type MaxFileSizeError = {
  files: File[];
  maxSize?: FileSize;
  maxSizeBytes?: number;
  maxSizeUnit?: string;
};
